import { render, staticRenderFns } from "./Credentials.vue?vue&type=template&id=2955926d&"
import script from "./Credentials.vue?vue&type=script&lang=js&"
export * from "./Credentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports